import type { Preview } from "@storybook/vue3";
import { setup } from "@storybook/vue3";
import plugins from "../src/plugins";
import { withVuetifyTheme } from 'website-addon-vuetify/.storybook/withVuetifyTheme.decorator';

import 'storybook-addon/src/assets/styles/index.scss'
import '../src/assets/styles/index.scss'

setup((app) => {
  app.use(plugins)
})

const preview: Preview = {
  parameters: {
    actions: { argTypesRegex: "^on[A-Z].*" },
    controls: {
      matchers: {
        color: /(background|color)$/i,
        date: /Date$/,
      },
    },
    options: {
      storySort: {
        order: ['Concept', ['Home', 'Page'], 'Components', ['Header', 'Footer', 'Menu'], 'Demo', ['Single Page', 'Single Page + Menu', 'Multi Page', 'Multi Language']]
      }
    },
    layout: 'fullscreen'
  },
};

export default preview;

export const decorators = [withVuetifyTheme];
